export const archivedLeadsConstants = {
  FETCH_ARCHIVED_LEADS: 'FETCH_ARCHIVED_LEADS',
  FETCH_ARCHIVED_LEADS_PAGE_WISE: 'FETCH_ARCHIVED_LEADS_PAGE_WISE',
  DELETE_LEAD: 'ArchivedLeads/DELETE_LEAD',
  REVERT_LEAD_STATUS: 'ArchiveLeads/REVERT_LEAD_STATUS',
};
